import gql from 'graphql-tag';

export const QUERY_PMS_LIST = gql`
  query CMS_listPMS {
    listPMS {
      pms {
        name
        status
        id
        emailAddress
        contact {
          contactName
        }
      }
    }
  }
`;

export const MUTATION_CREATE_PMS = gql`
  mutation CMS_CreatePMS($input: CreatePMSInput!) {
    createPMS(input: $input) {
      pms {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_PMS = gql`
  mutation CMS_UpdatePMS($input: UpdatePMSInput!) {
    updatePMS(input: $input) {
      pms {
        id
      }
    }
  }
`;

export const QUERY_PMS_DETAIL = gql`
  query CMS_queryPMSDetail($id: String, $landlordId: ID, $status: PMSIntegrationStatus) {
    getPMS(id: $id) {
      name
      status
      emailAddress
      note
      createdAt
      id
      contact {
        id
        contactEmail
        contactName
        contactPhone
        occupation
      }
      webhook {
        callbackUrl
      }
      landlords(landlordId: $landlordId, status: $status) {
        edges {
          node {
            status
            landlord {
              id
              slug
              accountManager
              propertiesCount
              name
            }
          }
        }
        totalCount
      }
    }
  }
`;

export const MUTATION_CREATE_PMS_CONTACT = gql`
  mutation CMS_CreatePMSContact($input: CreatePMSContactInput!) {
    createPMSContact(input: $input) {
      contact {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_PMS_CONTACT = gql`
  mutation CMS_UpdatePMSContact($input: UpdatePMSContactInput!) {
    updatePMSContact(input: $input) {
      contact {
        id
      }
    }
  }
`;

export const MUTATION_DELETE_PMS_CONTACT = gql`
  mutation CMS_DeletePMSContact($input: DeletePMSContactInput!) {
    deletePMSContact(input: $input) {
      contact {
        id
      }
    }
  }
`;
